import { PluginConfig } from '@src/slide/application/no-edit/service/no-edit-service/no-edit-service.interface';
import { LOGIN_PLUGIN_NAME } from '@src/slide/application/no-edit/plugins/login/login-plugin.interface';
import LoginPlugin from '@src/slide/application/no-edit/plugins/login/login-plugin';

export const LOGIN_PLUGIN_CONFIG: PluginConfig = {
    name: LOGIN_PLUGIN_NAME,
    plugin: LoginPlugin,
};
